// ----------------------------------------------------------------------
// <copyright file="Izenda.ScheduleBodyActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var defaultProps = require('recompose').defaultProps;
  const { curry } = require('lodash/fp');

  var scheduleBodyActions = compose(
    withHandlers({
      onSaveSchedule: curry(onSaveSchedule),
      onDeleteSchedule: curry(onDeleteSchedule),
      onCopySchedule: curry(onCopySchedule)
    })
  );

  /**
   * Save schedule data.
   * @param {Object} props
   * @param {Object} schedule data
   */
  function onSaveSchedule(props, schedule) {
    var subscribedInstances = props.subscribedInstancesStore.model;
    // Update for grid
    subscribedInstances.updateSubscribedInstances(schedule);
    // Update data for search & paging.
    subscribedInstances.updateScheduleInstances(false, schedule);
    // Update to report designer
    props.store.reportStore.model.updateSchedule(subscribedInstances.scheduleInstances);
  }

  /**
   * Delete schedule.
   * @param {Object} props
   * @param {Object} schedule data
   */
  function onDeleteSchedule(props, ids) {
    var subscribedInstances = props.subscribedInstancesStore.model;
    // Remove for grid
    subscribedInstances.removeSubscribedInstances(ids);
    // Remove data for search & paging.
    subscribedInstances.removeScheduleInstances(ids);
    // Update to report designer
    props.store.reportStore.model.updateSchedule(subscribedInstances.subscribedInstances);
  }

  /**
   * Copy schedule.
   * @param {Object} props
   * @param {Object} schedule data
   */
  function onCopySchedule(props, id) {
    var subscribedInstances = props.subscribedInstancesStore.model;
    // Update for grid
    subscribedInstances.copySubscribedInstance(id);
    // Copy data for search & paging.
    subscribedInstances.copyScheduleInstances(id);
    // Update to report designer
    props.store.reportStore.model.updateSchedule(subscribedInstances.scheduleInstances);
  }

  module.exports = scheduleBodyActions;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Schedule/Izenda.ScheduleBodyActions.js